import axios from 'axios'
import { name, version } from '../package.json'

// Dedicated axios instance for GraphQL requests only. We deliberately avoid
// axios.defaults.headers.common because this app also makes a public
// axios.get to the Google Fonts API (see store.js) — a global default header
// would leak these client attribution headers to Google.
export default axios.create({
  headers: {
    'x-sc-client-name': name,
    'x-sc-client-version': version
  }
})
